export default __webpack_public_path__ + "static/media/PlantillaPersonalEscuela.5da47680.jpeg";